import { AIContentGenerationCard } from './bento/AIContentGenerationCard';
import { AnalyticsInsightsCard } from './bento/AnalyticsInsightsCard';
import { HashtagManagerCard } from './bento/HashtagManagerCard';
import { ContentEditorCard } from './bento/ContentEditorCard';
import { useTranslation } from 'react-i18next';

export function BentoShowcase() {
    const { t } = useTranslation();
    return (
        <section className="py-20 px-4 sm:px-8 ">
            <div className="max-w-[1426px] mx-auto">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                        {t('landing.bento.heading')}
                    </h2>
                </div>

                {/* Bento Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-auto">

                    {/* 1. AI Content Generator (Top Left, 2x1) */}
                    <div className="col-span-1 md:col-span-2">
                        <AIContentGenerationCard />
                    </div>

                    {/* 3. Content Editor (Top Right, Tall 1x2) */}
                    <ContentEditorCard />

                    {/* 4. Hashtag Manager (Middle Left, Wide 2x1) */}
                    <HashtagManagerCard />

                    {/* 5. Analytics & AI Insights (Bottom, Full Width 3x1) */}
                    <AnalyticsInsightsCard />

                </div>


            </div>
        </section>
    );
}
